import React, { FC, Fragment, ReactNode, createContext, useContext } from 'react'
import { Theme, ThemeProvider } from '@mui/material/styles'

/**
 * Tema de la app (sin densidad compacta) publicado por el Modal cuando corre
 * con `compact`. Sirve para que las zonas del dialogo que NO son el formulario
 * — el header y la barra de acciones — se sigan viendo igual que en el resto
 * de los modales, que es lo que espera el usuario al comparar pantallas.
 */
export const ModalBaseThemeContext = createContext<Theme | null>(null)

interface BaseScaleProps {
  children: ReactNode
}

/**
 * Devuelve su contenido a la escala del tema de la app. Es un no-op cuando el
 * modal no es compacto (no hay tema base publicado), asi que se puede usar
 * siempre sin ramificar en el llamador.
 */
export const BaseScale: FC<BaseScaleProps> = ({ children }) => {
  const baseTheme = useContext(ModalBaseThemeContext)

  if (!baseTheme) return <Fragment>{children}</Fragment>

  return <ThemeProvider theme={baseTheme}>{children}</ThemeProvider>
}
